/*
  Debouncing is very useful with human interaction. However, It can become a headache when dealing with tests.
  We cannot stub them out of the box because default exports are already compiled.
  This wrapping method allows us to maintain compiled default exports while being able to stub out debounced delay.
  We could use a library to help out if this becomes a persistent problem. https://www.npmjs.com/package/proxyquire
*/

import lodashDebounce from 'lodash/debounce';

const stubbabbleExport = {
  debounce: lodashDebounce,
};

export const debounce: typeof lodashDebounce = (...args) => stubbabbleExport.debounce(...args);

// oxlint-disable-next-line import/no-default-export
export default stubbabbleExport;
